import { Provider } from '@angular/core';

import { runOnBrowserAppInit } from '../bootstrap/bootstrapper.service';
import { RegistrationInfoBootstrapService } from './registration-info-bootstrap.service';

export function provideRegistrationInfo(): Provider[] {
    return [runOnBrowserAppInit(RegistrationInfoBootstrapService)];
}
